import axios from 'axios'

export default {
  accessgroupmemberList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/accessgroupmember', { params: opts })
        .then(({ data }) => {
          context.commit('ACCESS_GROUP_MEMBER_LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // ===========================Socket Updates=====================
  accessgroupmemberUpdated (context, opts) {
    const id = opts && opts.id ? opts.id : opts
    const populated = opts && opts.populate ? opts.populate : []
    const inList = context.state.list.find((i) => i.id === id)
    if (inList) {
      axios
        .get(`/api/accessgroupmember/${id}`, { params: populated })
        .then(({ data }) => {
          if (data.id) {
            data.socketUpdate = true
            context.commit('ACCESS_GROUP_MEMBER_LIST_UPDATE', data)
          }
        }).catch(() => {})
    }
  },
  accessgroupmemberDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inList = context.state.list.find((i) => i.id === id)
    if (id === context.state.current.id) {
      context.commit('ACCESS_GROUP_MEMBER_CURRENT', null)
    }
    if (inList) {
      context.commit('ACCESS_GROUP_MEMBER_LIST_REMOVE', id)
    }
  }
}
